import React, { Component } from 'react';
import ReactDOM from 'react-dom';


const modalRoot = document.getElementById('root');
class Error extends Component {
    static defaultProps = {
        handleHide: () => {
          console.log("props가 없습니다");
        },
        errorContent: {},
        handleDetail:()=> {
            console.log("props가 없습니다");
        },
    };
    constructor(props){
        super(props);
          this.state={
            showDetail: false,
            toggleText: '자세한 정보 열기',
            toggleClass: 'modal-content',
        }
        this.handleDetail = this.handleDetail.bind(this);
    }
   
    handleDetail(){
        this.state.showDetail ? 
        this.setState({
          showDetail: false,
          toggleText: '자세한 정보 열기',
          toggleClass: 'modal-content'
        }) :
        this.setState({
          showDetail: true,
          toggleText: '자세한 정보 닫기',
          toggleClass: 'modal-content show-content'
        });
    }


    render() {
        const {
            showDetail,
            toggleText,
            toggleClass 
        } = this.state;
        const {
            handleHide,
            errorContent,
        } = this.props;

      return ReactDOM.createPortal(
        <div id='modal-wrap'>
            <div className = 'modal-err'>
                <div className = 'modal-header'>요청결과에 오류가 있습니다.
                    <span className='icon modal-close' onClick={handleHide}></span>
                </div>
                <div className = 'modal-body'>
                    <div className = 'modal-title'>{errorContent.code}, {errorContent.content}</div>
                    <button className = 'modal-toggle' onClick={this.handleDetail}>{toggleText}</button>
                    <div className = {toggleClass}>{showDetail ? errorContent.detail : ''} </div>
                </div>
            </div>
        </div>
      , modalRoot);
    }
  }
  
  export default Error;


// WEBPACK FOOTER //
// ./src/components/modal/Error.js